export default "__VITE_ASSET__Dt1snLGU__"